import React from 'react';
import { ScrollText } from 'lucide-react';
import { Checkbox } from '../ui/checkbox';

export const REGLES_RCDS = [
  "Adhésion FTPE (200 €) : dès le paiement, vous recevez votre attestation FTPE et votre reçu de paiement « Acquitté ».",
  "Contribution RCDS BATICO (Annuel, Nominative ou ARCHOS) : l'attestation RCDS vous est envoyée dès le paiement de l'acompte (ou du paiement en une fois), à l'état « Paiement partiel — Attestation valide ».",
  "Le QR code de vérification de l'attestation affiche son état en temps réel.",
  "Dès le lendemain d'une échéance non réglée, l'attestation passe à l'état « Impayé » avec la mention « Attestation invalide ».",
  "Si vous régularisez avant la date de l'échéance suivante, l'attestation repasse à l'état « Paiement partiel — Attestation valide ».",
  "Après deux échéances impayées, le contrat passe à l'état « Résilié ». Il est réactivé automatiquement dès que vous réglez les échéances dues et une contribution suspensive, dont le montant vous est indiqué à ce moment-là.",
  "Une fois votre contribution entièrement payée, vous recevez votre reçu avec la mention « Acquitté ».",
];

export const REGLES_DOMIUM = [
  "Paiement en une fois : votre attestation DOS-DOMIUM et votre reçu « Acquitté » vous sont envoyés dès le paiement.",
  "Paiement en 4 fois : l'attestation DOS-DOMIUM vous est envoyée dès le paiement de l'acompte de 60 %, à l'état « Paiement partiel — Attestation valide ».",
  ...REGLES_RCDS.slice(2, 6),
  "Une fois votre contribution entièrement payée, vous recevez votre attestation définitive et votre reçu avec la mention « Acquitté ».",
];

export const ReglesPaiement = ({ accepted, acceptedAt, onChange, regles = REGLES_RCDS }) => (
  <div className="rounded-lg border border-amber-200 bg-amber-50/60 p-4 space-y-3" data-testid="regles-paiement">
    <p className="flex items-center gap-2 text-sm font-semibold text-amber-900"><ScrollText className="h-4 w-4" /> Règles de paiement et de validité des attestations</p>
    <ol className="list-decimal pl-5 space-y-1 text-xs text-slate-700" data-testid="regles-paiement-liste">
      {regles.map((r) => <li key={r}>{r}</li>)}
    </ol>
    {acceptedAt ? (
      <p className="text-xs text-emerald-700 font-medium" data-testid="regles-acceptees">Règles acceptées le {new Date(acceptedAt).toLocaleDateString('fr-FR')}.</p>
    ) : (
      <label className="flex items-start gap-2 text-sm text-slate-800 cursor-pointer">
        <Checkbox checked={accepted} onCheckedChange={(v) => onChange(!!v)} className="mt-0.5" data-testid="regles-accept-checkbox" />
        <span>J'ai lu et j'accepte les règles de paiement et de validité des attestations.</span>
      </label>
    )}
  </div>
);
